import DragDropContext from './DragDrop';
import InternalDragDrop from './Droppable';
import Item from './DragDropItem';

type InternalDragDropType = typeof DragDropContext;

interface DragDropProps extends InternalDragDropType {
  Droppable: typeof InternalDragDrop;
  Item: typeof Item;
}

const DragDrop = DragDropContext as DragDropProps;

DragDrop.Item = Item;
DragDrop.Droppable = InternalDragDrop;

export default DragDrop;
